import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const SelectedIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.99999 1.6665C5.40832 1.6665 1.66666 5.40817 1.66666 9.99984C1.66666 14.5915 5.40832 18.3332 9.99999 18.3332C14.5917 18.3332 18.3333 14.5915 18.3333 9.99984C18.3333 5.40817 14.5917 1.6665 9.99999 1.6665ZM13.9833 8.08317L9.25832 12.8082C9.14166 12.9248 8.98332 12.9915 8.81666 12.9915C8.64999 12.9915 8.49166 12.9248 8.37499 12.8082L6.01666 10.4498C5.77499 10.2082 5.77499 9.80817 6.01666 9.5665C6.25832 9.32484 6.65832 9.32484 6.89999 9.5665L8.81666 11.4832L13.1 7.19984C13.3417 6.95817 13.7417 6.95817 13.9833 7.19984C14.225 7.4415 14.225 7.83317 13.9833 8.08317Z"
				fill="#2AB644"
			/>
		</svg>
	);
};

export default memo(SelectedIcon);
